import { create } from "zustand";
import api from "./api";

export const useStore = create((set, get) => ({
  token: localStorage.getItem("tgc_jwt") || null,
  user: null,
  wallets: null,
  tgcPrice: 0.10,
  stakes: [],
  merchants: [],
  products: [],
  referral: null,
  transactions: [],
  toast: null,

  setToast: (type, message) => {
    set({ toast: { type, message, ts: Date.now() } });
    setTimeout(() => {
      if (get().toast?.ts && Date.now() - get().toast.ts >= 3000) set({ toast: null });
    }, 3100);
  },

  register: async (data) => {
    const r = await api.post("/auth/register", data);
    localStorage.setItem("tgc_jwt", r.data.token);
    set({ token: r.data.token, user: r.data.user });
    await get().fetchAll();
    return r.data.user;
  },

  login: async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("tgc_jwt", r.data.token);
    set({ token: r.data.token, user: r.data.user });
    await get().fetchAll();
    return r.data.user;
  },

  logout: () => {
    localStorage.removeItem("tgc_jwt");
    set({ token: null, user: null, wallets: null, stakes: [], referral: null });
  },

  fetchMe: async () => {
    try {
      const r = await api.get("/auth/me");
      set({ user: r.data });
    } catch { get().logout(); }
  },

  fetchWallets: async () => {
    const r = await api.get("/wallets");
    set({ wallets: r.data.wallets, tgcPrice: r.data.tgcPriceEur });
  },

  fetchStakes: async () => {
    const r = await api.get("/staking/my");
    set({ stakes: r.data.stakes });
  },

  fetchMerchants: async () => {
    const r = await api.get("/merchants");
    set({ merchants: r.data.merchants });
  },

  fetchProducts: async () => {
    const r = await api.get("/marketplace/products");
    set({ products: r.data.products });
  },

  fetchReferral: async () => {
    const r = await api.get("/referral/my");
    set({ referral: r.data });
  },

  fetchTransactions: async () => {
    const r = await api.get("/transactions");
    set({ transactions: r.data.transactions });
  },

  fetchAll: async () => {
    await Promise.all([
      get().fetchMe(),
      get().fetchWallets(),
      get().fetchStakes(),
      get().fetchMerchants(),
      get().fetchProducts(),
      get().fetchReferral(),
      get().fetchTransactions(),
    ]);
  },

  submitKYC: async (payload = {}) => {
    await api.post("/kyc/submit", payload);
    get().setToast("success", "KYC отправлен. Одобрение через 3 сек (DEMO)");
    setTimeout(() => get().fetchMe(), 4000);
  },

  updateProfile: async (patch) => {
    const r = await api.patch("/profile", patch);
    set({ user: r.data });
    get().setToast("success", "Профиль обновлён");
    return r.data;
  },

  transferWallet: async (fromWallet, toWallet, amount) => {
    await api.post("/wallets/transfer", { fromWallet, toWallet, amount });
    await get().fetchWallets();
    await get().fetchTransactions();
    get().setToast("success", `Переведено ${amount} TGC`);
  },

  createStake: async (packageId) => {
    const r = await api.post("/staking/create", { packageId });
    await get().fetchWallets();
    await get().fetchStakes();
    get().setToast("success", `Стейк создан на ${r.data.amountTgc.toFixed(0)} TGC`);
  },

  payQR: async (merchantId, amount) => {
    const r = await api.post("/pay/qr", { merchantId, amount });
    await get().fetchWallets();
    await get().fetchTransactions();
    get().setToast("success", `Оплачено ${amount}€ · +${r.data.energyEarned} EP ⚡`);
    return r.data;
  },

  buyProduct: async (productId) => {
    await api.post(`/marketplace/buy/${productId}`);
    await get().fetchWallets();
    await get().fetchTransactions();
    get().setToast("success", "Покупка успешна!");
  },

  tradeOrder: async (pair, side, amount, price) => {
    await api.post("/exchange/order", { pair, side, orderType: price ? "limit" : "market", amount, price });
    get().setToast("success", `${side.toUpperCase()} ${amount} ${pair.split("/")[0]}`);
  },

  aiChat: async (message, sessionId) => {
    const r = await api.post("/ai/chat", { message, sessionId });
    return r.data;
  },
}));
